<template>
  <div v-if="editModeActive">
    <div class="form-group" style="margin-bottom: 0.9em">
      <el-input
        type="textarea"
        style="width: 95%; font-size: 12pt; white-space: nowrap; overflow: auto; font-family: monospace"
        autosize
        v-model="internal_text"
        ref="text_input"
        :placeholder="placeholder"
      />
      <!--
      wrap="soft"
      @focus="focus"
      @blur="unfocus"
      @keyup="hasUnsavedChanges = true"
      @input.passive="updateRows"
    -->
      <div class="btn-group">
        <button class="btn btn-success btn-sm selectgroup-item" type="button" @click="updateText">Save</button>
        <button class="btn btn-primary btn-sm selectgroup-item" type="button" @click="enterEditMode({status: false})">Cancel</button>
      </div>
    </div>
  </div>
  <div v-else>
    <div @click="editOnClick && enterEditMode({status: true})" style="position: relative">
      <slot v-bind:text="text">
        <div v-if="showAsMarkdown" v-html="compiledMarkdown"></div>
        <p v-else style="white-space: pre; border: 1px dashed grey; min-height: 2em" class="p-1 m-0">{{text}}</p>
        <font-awesome-icon
          v-show="isEditable"
          style="cursor: pointer; position: absolute; right: 8px; top: 8px"
          icon="edit"
          @click="enterEditMode({status: !editModeActive})" />
      </slot>
    </div>
  </div>
</template>

<script>
// import { mapMutations } from 'vuex'

import marked from 'marked'

/* TODO: zusammenführen mith editable Text? */

export default {
  props: {
    placeholder: {
      type: String,
      default: "Try some markdown"
    },
    id: {
      type: String
    },
    text: {
      type: String,
      default: ""
    },
    showAsMarkdown: {
      type: Boolean,
      default: false
    },
    editOnClick: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    id() {
      /* Set edit mode to false when goal is changed */
      this.editModeActive = false;
      // setTimeout(() => {
      //   /* HACK */
      //   this.UNSUPPRESS_KEYBOARD_LISTENER();
      // }, 100);
    },
    text(new_text) {
      this.internal_text = new_text;
    }
  },

  components: {
  },

  data() {
    return {
      hasUnsavedChanges: false,
      editModeActive: false,
      internal_text: '',
      // num_of_rows: 1
    };
  },

  created() {
    this.internal_text = this.text;
  },

  // beforeDestroy() {
  //   this.UNSUPPRESS_KEYBOARD_LISTENER();
  // },

  computed: {
    compiledMarkdown() {
      const markdownMagicWord = '#MARKDOWN:';
      let text = this.text;
      if ( this.text && this.text.startsWith(markdownMagicWord) ) {
        text = text.slice(markdownMagicWord.length);
      }
      return marked(text, { sanitize: true });
    }
  },

  methods: {
    // ...mapMutations("project<<", [
    //   "SUPPRESS_KEYBOARD_LISTENER",
    //   "UNSUPPRESS_KEYBOARD_LISTENER"
    // ]),

    updateRows() {
      // this.num_of_rows = this.num_of_rows + 1
      // this.num_of_rows = this.$refs.text_input.value.split(/\r\n|\r|\n/).length + 1
      // this.$refs.text_input.style.height = ( 5 + 14 * this.num_of_rows ) + "pt";
    },

    focus(evt) {
      // this.SUPPRESS_KEYBOARD_LISTENER();
    },

    unfocus(evt) {
      // setTimeout(() => {
      //   this.UNSUPPRESS_KEYBOARD_LISTENER();
      // }, 100);
    },

    updateText: function (event) {
      // let text = this.$refs.text_input.value;

      this.hasUnsavedChanges = false;
      this.enterEditMode({ status: false });

      this.$emit("update", this.internal_text);
    },

    enterEditMode: function({ status }) {
      if ( !this.isEditable ) {
        return
      }
      this.editModeActive = status;
      this.$nextTick(() => {
        if ( this.$refs.text_input ) {
          // this.$refs.text_input.resizeTextarea();
          this.$refs.text_input.focus()
        }
      })
    }
  }
}
</script>
